export const cleanCssIdentifier = (identifier) => {
    const filter = {
        ' ': '-',
        _: '-',
        '/': '-',
        '[': '-',
        ']': '',
    };
    let result = identifier.toLowerCase();
    Object.keys(filter).forEach((key) => {
        result = result.split(key).join(filter[key]);
    });
    result = result.replace(/[^\-0-9a-z\u00A1-\uFFFF]/gu, '');
    if (/^[0-9]/.test(result)) {
        result = '_' + result;
    }
    else if (/^(-[0-9])|^(--)/.test(result)) {
        result = '_' + result;
    }
    return result;
};
/**
 * Removes HTML tags and decodes HTML entities from a string.
 * Normalizes whitespace: multiple spaces/tabs become single space, but preserves line breaks (\n).
 * @param str - Input string that may contain HTML tags and entities
 * @returns Plain text string with HTML tags removed and entities decoded
 */
export const stripHtmlTags = (str) => {
    if (!str)
        return undefined;
    const sanitized = str
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'")
        // Normalize multiple spaces/tabs to single space, but preserve line breaks
        .replace(/[ \t]+/g, ' ')
        // Normalize multiple consecutive line breaks to single line break
        .replace(/\n{2,}/g, '\n')
        // Remove space before line breaks
        .replace(/ +\n/g, '\n')
        // Remove space after line breaks
        .replace(/\n +/g, '\n')
        .trim();
    return sanitized || undefined;
};
export function deEscapeCharacters(text) {
    // List of most common escaped characters
    const entities = {
        '&quot;': '"',
        '&apos;': "'",
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&nbsp;': ' ',
        '&copy;': '©',
        '&reg;': '®',
        '&trade;': '™',
        '&euro;': '€',
        '&pound;': '£',
        '&yen;': '¥',
        '&cent;': '¢',
        '&sect;': '§',
        '&deg;': '°',
        '&bull;': '•',
        '&ndash;': '–',
        '&mdash;': '—',
        '&lsquo;': '‘',
        '&rsquo;': '’',
        '&ldquo;': '“',
        '&rdquo;': '”',
        '&hellip;': '…',
        '&times;': '×',
        '&divide;': '÷',
        '&#34;': '"',
        '&#39;': "'",
        '&#38;': '&',
        '&#60;': '<',
        '&#62;': '>',
        '&#160;': ' ',
        '&#169;': '©',
        '&#174;': '®',
        '&#8482;': '™',
        '&#8364;': '€',
        '&#163;': '£',
        '&#165;': '¥',
        '&#162;': '¢',
        '&#167;': '§',
        '&#176;': '°',
        '&#8226;': '•',
        '&#8211;': '–',
        '&#8212;': '—',
        '&#8216;': '‘',
        '&#8217;': '’',
        '&#8220;': '“',
        '&#8221;': '”',
        '&#8230;': '…',
        '&#215;': '×',
        '&#247;': '÷',
    };
    return text.replace(/&[a-z]+;/g, (match) => entities[match] || match);
}
/**
 * Converts a string to PascalCase.
 *
 * @param {string} str - The input string to convert.
 * @returns {string} - The string converted to PascalCase.
 */
export const toPascalCase = (str) => {
    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .split(/[-_ ]+/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join('');
};
/**
 * Converts a string to camelCase (lowercase first letter).
 *
 * @param str - The input string to convert.
 * @returns The string in camelCase.
 */
export const toCamelCase = (str) => {
    const pascal = toPascalCase(str);
    return pascal.length > 0 ? pascal.charAt(0).toLowerCase() + pascal.slice(1) : pascal;
};
//# sourceMappingURL=stringUtils.js.map